<template>
    <basic-container>
        <!-- ------搜索栏功能 -------->
        <div class="query-form-wrap">
            <div class="query-form-wrap-left">
                <el-form :inline="true" :model="searchForm" size="small">
                    <el-form-item label="媒资名称">
                        <el-input clearable v-model="searchForm.name" placeholder="请输入媒资名称">
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="媒资资源">
                        <el-select v-model="searchForm.mediaType" clearable placeholder="全部">
                            <el-option v-for="item in mediaType" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" clearable placeholder="全部">
                            <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="方式">
                        <el-select v-model="searchForm.initialType" clearable placeholder="全部">
                            <el-option v-for="item in initialType" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :span="20">
                        <el-button v-auth="'MARKMANAGE_HOTLIST_SEARCH'" icon="el-icon-search" size="small" type="primary"
                            @click="handleSearch">搜索</el-button>
                        <el-button icon="el-icon-delete" size="small" @click="handleClear">清空</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <!-- //^ ^--------------表格 start-------------^ ^ -->
        <div>
            <el-button size="small" type="primary" @click="handleAdd">新增</el-button>
        </div>
        <br />
        <!-- //^ ^--------------标签栏-------------^ ^ -->
        <el-tabs v-model="searchForm.mediaType" @tab-click="handleTabClick">
            <el-tab-pane label="电视剧" :name="1"></el-tab-pane>
            <el-tab-pane label="电影" :name="2"></el-tab-pane>
            <el-tab-pane label="少儿" :name="4"></el-tab-pane>
            <el-tab-pane label="综艺" :name="3"></el-tab-pane>
        </el-tabs>
        <br />
        <el-table :data="hotListData" border style="width: 100%" height="500">
            <el-table-column type="index" width="50" label="序号"> </el-table-column>
            <el-table-column prop="coverImage" width="100" label="媒资图片">
                <template v-slot="data">
                    <!-- <el-image :src="data.row.coverImage" alt="" /> -->
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <ImageIframe style="width: 75px; height: 100px;" v-if="isShowIframe" :url="data.row.coverImage">
                        </ImageIframe>

                    </div>

                </template>
            </el-table-column>
            <el-table-column width="100" prop="name" label="媒资名称"> </el-table-column>
            <el-table-column width="80" prop="type" label="媒资类型">
                <template v-slot="data">
                    {{ valueToLabel(typeOptions, data.row.type) }}
                </template>
            </el-table-column>
            <el-table-column width="80" prop="hotval" label="热度值"> </el-table-column>
            <el-table-column width="50" prop="status" label="状态">
                <template v-slot="data">
                    <span :class="{ gary: data.row.status === 2 }">
                        {{ valueToLabel(statusOptions, data.row.status) }}</span>
                </template>
            </el-table-column>
            <el-table-column width="50" prop="initialType" label="方式">
                <template v-slot="data">
                    <span :class="{ red: data.row.initialType === 2 }">
                        {{ valueToLabel(initTypeOptions, data.row.initialType) }}</span>
                </template>
            </el-table-column>
            <el-table-column width="120" label="播放源">
                <template v-slot="data">
                    <div>
                        <div v-if="data.row.payType[0]">{{ data.row.payType[0] }}</div>
                        <div v-if="data.row.payType[1]">{{ data.row.payType[1] }}</div>
                        <div v-if="data.row.payType[2]">{{ data.row.payType[2] }}</div>
                        <div v-if="!data.row.payType[0] &&
                            !data.row.payType[1] &&
                            !data.row.payType[2]
                            ">
                            暂无播放源
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="媒资标签">
                <template v-slot="data">
                    <el-popover placement="top-start" trigger="hover" :content="data.row.tagName">
                        <div slot="reference" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                            <el-tag style="margin-right: 10px;" v-for="item in data.row.tagName.split(',')" :key="item.id">
                                {{ item }}
                            </el-tag>
                        </div>

                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="description" label="媒资简介" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="updateTime" label="最后更新时间" width="180">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-auth="'MARKMANAGE_HOTLIST_CANCEL'" type="text" size="small"
                        v-show="scope.row.initialType === 2 && scope.row.status === 1"
                        @click="cancelIntervention(scope.row)">取消人工干预</el-button>
                    <el-button v-auth="'MARKMANAGE_HOTLIST_EDIT'" type="text" size="small"
                        @click="handleEdit(scope.row, scope.$index)">编辑</el-button>
                    <el-button v-auth="'MARKMANAGE_HOTLIST_VIEW'" type="text" size="small"
                        @click="handleView(scope.row)">查看</el-button>
                    <el-button v-auth="'MARKMANAGE_HOTLIST_STATE'" type="text" size="small" v-show="scope.row.status === 2"
                        @click="handlePuton(scope.row, index)">上架</el-button>
                    <el-button v-auth="'MARKMANAGE_HOTLIST_STATE'" type="text" size="small" v-show="scope.row.status === 1"
                        @click="handleTokeOff(scope.row, index)">下架</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- //^ ^--------------表格 end-------------^ ^ -->

        <!-- //^ ^--------------查看/编辑的对话框-------------^ ^ -->
        <el-dialog :title="isEdit ? '编辑' : '查看'" :visible.sync="viewDialog" width="60%" @closed="isEdit = false"
            :modal-append-to-body="false">
            <el-form ref="viewForm" :model="viewForm" :rules="rules">
                <el-form-item prop="sortNo" v-if="isEdit" label="人工排序:" label-width="20%">
                    <el-input show-word-limit maxlength="50" type="textarea" :autosize="{ minRows: 2, maxRows: 8 }"
                        v-model.number="viewForm.sortNo" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item prop="mediaAsset.name" label="媒资名称:" label-width="20%">
                    <el-input show-word-limit :disabled="disabled" maxlength="50" type="textarea"
                        :autosize="{ minRows: 2, maxRows: 8 }" v-model="viewForm.mediaAsset.name"
                        placeholder="请输入媒资名称"></el-input>
                </el-form-item>
                <el-form-item prop="mediaAsset.aliasName" label="媒资别名:" label-width="20%">
                    <el-input show-word-limit :disabled="disabled" maxlength="50" type="textarea"
                        :autosize="{ minRows: 2, maxRows: 8 }" v-model="viewForm.mediaAsset.aliasName" :placeholder="viewForm.mediaAsset.aliasName
                            ? viewForm.mediaAsset.aliasName
                            : '暂无媒资别名'
                            "></el-input>
                </el-form-item>
                <el-form-item prop="mediaAsset.type" label="媒资类型:" label-width="20%">
                    <span>{{ valueToLabel(typeOptions, viewForm.mediaAsset.type) }}</span>
                </el-form-item>
                <el-form-item prop="drama.episodes" label="集数:" label-width="20%">
                    <span>{{
                        viewForm.drama.episodes ? viewForm.drama.episodes : "集数未知"
                    }}</span>
                </el-form-item>
                <el-form-item prop="mediaAsset.description" label="简介:" label-width="20%">
                    <el-input show-word-limit :disabled="disabled" maxlength="500" type="textarea"
                        :autosize="{ minRows: 2, maxRows: 8 }" v-model="viewForm.mediaAsset.description"
                        placeholder="请输入简介"></el-input>
                </el-form-item>
                <!-- //^ ^--------------封面图-------------^ ^ -->
                <el-form-item prop="mediaAsset" label="简介:" label-width="20%">
                    <div class="showMediaImg">
                        <div class="showMediaImg-left">
                            <span>封面图: </span>
                            <ImageIframe v-if="viewForm.mediaAsset.isShowCoverImage" :url="viewForm.mediaAsset.coverImage">
                            </ImageIframe>
                            <span v-if="!viewForm.mediaAsset.coverImage">暂无图片</span>
                        </div>
                        <div class="showMediaImg-right">
                            <span>高清横屏图: </span>
                            <ImageIframe v-if="viewForm.mediaAsset.isShowHdImage" :url="viewForm.mediaAsset.hdImage">
                            </ImageIframe>
                            <span v-if="!viewForm.mediaAsset.hdImage">暂无图片</span>
                            <el-upload v-show="!disabled" class="upload-demo" :before-upload="checkUpload"
                                :http-request="upload" listType="picture-img" action="hdImage" :on-preview="handlePreview"
                                :on-remove="handleRemove" :before-remove="beforeRemove" :on-exceed="handleExceed"
                                :show-file-list="false">
                                <el-button size="small" type="primary">重新上传</el-button>
                                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                            </el-upload>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="mediaAsset.score" label="评分:" label-width="20%">
                    {{ viewForm.mediaAsset.score }}
                </el-form-item>
                <el-form-item prop="mediaAsset.url" label="页面访问地址:" label-width="20%">
                    {{ viewForm.mediaAsset.url }}
                </el-form-item>
                <el-form-item prop="mediaAsset.urlScheme" label="app跳转地址:" label-width="20%">
                    {{ viewForm.mediaAsset.urlScheme }}
                </el-form-item>
                <el-form-item prop="mediaAsset.tagName" label="备注:" label-width="20%">
                    <el-input show-word-limit :disabled="disabled" maxlength="99" type="textarea"
                        :autosize="{ minRows: 2, maxRows: 8 }" v-model="viewForm.mediaAsset.tagName" :placeholder="viewForm.mediaAsset.tagName
                            ? viewForm.mediaAsset.tagName
                            : '暂无备注'
                            "></el-input>
                </el-form-item>
                <el-form-item prop="mediaAsset.sourceType" label="来源平台:" label-width="20%">
                    {{
                        valueToLabel(sourcePlatformOptions, viewForm.mediaAsset.sourceType)
                    }}
                </el-form-item>
                <!-- //^ ^--------------演职员表-------------^ ^ -->
                <div style="width: 100%; max-height: 31.25rem; overflow: auto;">
                    <el-form-item prop="staffMembers" label="明星列表:" label-width="20%">
                        <div class="showMediaImg" v-if="viewForm.staffMembers.length">
                            <div v-for="item in viewForm.staffMembers" :key="item.id" class="showMediaImg-left">
                                <ImageIframe v-if="viewForm.mediaAsset.isShowActorImage" :url="item.headImage">
                                </ImageIframe>
                                <span v-if="!item.headImage">暂无图片</span>
                                <p>演员：{{ item.name }}</p>
                                <p style="margin-top: -1.25rem;">
                                    职务：{{ valueToLabel(actorDutyOptions, item.position) }}
                                </p>
                            </div>
                        </div>
                        <div v-else>
                            暂无数据
                        </div>
                    </el-form-item>
                </div>

                <!-- //^ ^--------------剧集列表-------------^ ^ -->
                <div style="width: 100%; max-height: 31.25rem; overflow: auto; margin-top: 3.125rem;">
                    <el-form-item label="剧集列表:" label-width="20%">
                        <el-table :data="viewForm.episodes" border style="width: 100%">
                            <el-table-column prop="episodeName" label="集名">
                            </el-table-column>
                            <el-table-column prop="duration" label="时长"> </el-table-column>
                            <el-table-column prop="url" label="页面访问地址">
                            </el-table-column>
                            <el-table-column prop="urlScheme" label="app跳转地址">
                            </el-table-column>
                            <!-- <el-table-column prop="episodeType" label="类型">
                                      </el-table-column> -->
                        </el-table>
                    </el-form-item>
                </div>
            </el-form>
            <span v-show="isEdit" slot="footer" class="dialog-footer">
                <el-button @click="editDialogCancel">取 消</el-button>
                <el-button type="primary" @click="editDialogConfirm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- //^ ^--------------新增对话框-------------^ ^ -->
        <!-- //^ ^--------------新增时多选主媒资的对话框-------------^ ^ -->
        <el-dialog title="新增媒资" :visible.sync="addDialog" width="60%" :modal-append-to-body="false">
            <!-- //^ ^--------------搜索栏配置-------------^ ^ -->
            <div class="query-form-wrap-left" style="margin-top: -30px;">
                <el-form :inline="true" :model="addSearchForm" size="small">
                    <el-form-item label="媒资名称">
                        <el-input clearable v-model="addSearchForm.name" placeholder="请输入媒资名称"></el-input>
                    </el-form-item>
                    <el-form-item label="媒资资源">
                        <el-select v-model="addSearchForm.type" placeholder="全部">
                            <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item prop="channelNameStr">
                        <el-select v-model="addSearchForm.sourceType" clearable placeholder="请选择来源平台">
                            <el-option v-for="item in sourceType" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input clearable v-model="addSearchForm.staffMemberName" placeholder="明星姓名"></el-input>
                    </el-form-item> -->
                    <el-form-item :span="20">
                        <el-button icon="el-icon-search" type="primary" @click="handleAddSearch">搜索</el-button>
                        <el-button icon="el-icon-delete" @click="handleAddClear">清空</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- //^ ^--------------表格-------------^ ^ -->
            <el-form style="margin-top: -20px;" ref="addDataForm" size="small" :model="addDataForm" :rules="addDataRules">
                <el-table height="400" :data="addData" row-key="id" @selection-change="selectMedia" border
                    style="width: 100%;margin-top: 1.25rem;">
                    <el-table-column prop="exist" width="50">
                        <template slot-scope="scope">
                            <el-radio :disabled="scope.row.exist" @input="selectMedia" v-model="isChecked"
                                :label="scope.row">&nbsp;
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column width="80" label="媒资图片">
                        <template slot-scope="scope">
                            <div style="display: flex;justify-items: center;align-items: center;">
                                <ImageIframe style="width: 75px; height: 100px;" :url="scope.row.coverImage"></ImageIframe>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="150" prop="name" label="媒资名称"> </el-table-column>
                    <el-table-column width="80" prop="type" label="媒资类型">
                        <template v-slot="data">
                            {{ valueToLabel(typeOptions, data.row.type) }}
                        </template>
                    </el-table-column>
                    <el-table-column width="150" label="排序">
                        <template v-slot="scope">
                            <el-form-item label=" " :prop="scope.row.id">
                                <el-input :disabled="scope.row.exist" v-model="scope.row.sortNo" />
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" prop="sourceType" label="播放源">
                        <template v-slot="data">
                            <!-- {{ valueToLabel(sourcePlatformOptions, data.row.sourceType) }} -->
                            <div>
                                <div v-if="data.row.payType[0]">{{ data.row.payType[0] }}</div>
                                <div v-if="data.row.payType[1]">{{ data.row.payType[1] }}</div>
                                <div v-if="data.row.payType[2]">{{ data.row.payType[2] }}</div>
                                <div v-if="!data.row.payType[0] &&
                                    !data.row.payType[1] &&
                                    !data.row.payType[2]
                                    ">
                                    暂无播放源
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tagName" label="媒资标签">
                        <template slot-scope="{ row }">
                            <el-popover placement="top-start" width="200" trigger="hover" :content="row.tagName">
                                <div slot="reference"
                                    style="width: 300px; margin-bottom: 5px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                    <el-tag style="margin-right: 10px;" v-for="item in row.tagName.split(',')"
                                        :key="item.id">
                                        {{ item }}
                                    </el-tag>
                                </div>

                            </el-popover>
                            <!-- <div style="display: flex;flex-wrap: wrap;">
                                <el-tag style="margin-right: .625rem; margin-bottom: .3125rem"
                                    v-for="item in row.tagName.split(',')" :key="item.id">
                                    {{ item }}
                                </el-tag>
                            </div> -->
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="操作">
                        <template slot-scope="{ row }">
                            <el-button size="small" type="text" @click="handleGetDetail(row, index)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div class="pagination"
                style="text-align: right; margin-top: 1.25rem;display: flex;justify-content: space-between;">
                <el-pagination @size-change="handleAddSizeChange" @current-change="handleAddCurrentChange"
                    :current-page="addSearchForm.current" :page-sizes="[10, 20, 30, 40]" :page-size="addSearchForm.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="addSearchForm.total">
                </el-pagination>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleAddCancel">取 消</el-button>
                    <el-button type="primary" @click="handleAddConfirm">确 定</el-button>
                </span>
            </div>

        </el-dialog>

        <!-- //^ ^--------------分页 start-------------^ ^ -->
        <br />
        <div class="pagination" style="text-align: right">
            <ElementPagination :current-page="searchForm.current" :page-size="searchForm.size" :total="searchForm.total"
                :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
        <br />
        <!-- //^ ^--------------分页 end-------------^ ^ -->
    </basic-container>
</template>

<script>
import {
    getHotList,
    addHotList,
    updateHotListOrder,
    takeOnHotList,
    takeOffHotList
} from "@/api/markManage/hotList";
import { getMediaDetail, getPrimaryMedia } from "@/api/markManage/mediaManage";
import mixins from "./utils/mixins";
import ElementPagination from "@/components/ElementPagination";
import ImageIframe from "./img_iframe.vue";
import Message from "@/components/Message";
import moment from "moment";
import { formatPayType } from "./utils";
export default {
    name: "WebSassMediaManage",
    mixins: [mixins],
    components: {
        ElementPagination,
        ImageIframe
    },
    computed: {
        addDataForm() {
            const data = this.addData.reduce((data, { id, sortNo }) => {
                data[id] = sortNo;
                return data;
            }, {});
            console.log("data", data);
            return data;
        },
        addDataRules() {
            const rules = this.addData.reduce((rules, { id, isChecked }) => {
                if (isChecked) {
                    rules[id] = [
                        { required: true, message: "请输入排序序号", trigger: "blur" },
                        {
                            message: "请输入正整数",
                            trigger: ["blur", "change"],
                            validator: (rule, value, callback) => {
                                if (/^[1-9]\d*$/.test(value)) {
                                    callback();
                                } else {
                                    callback(new Error());
                                }
                            }
                        }
                    ];
                } else {
                    /** 清除验证 */
                    rules[id] = [];
                    // 清除错误提示信息
                    const elForm = this.$refs.addDataForm;
                    elForm.clearValidate(`${id}`);
                }
                return rules;
            }, {});
            console.log("rules", rules);
            return rules;
        }
    },
    data() {
        return {
            /** 新增媒资是否选中 */
            isChecked: "",
            /** 选中的媒资id */
            /** */
            isShowIframe: false,
            /** 搜索栏配置 */
            searchForm: {
                current: 1,
                size: 10,
                total: 0,
                name: null,
                mediaType: 1,
                status: null,
                initialType: null
            },
            /** 表格展示数据 */
            hotListData: [],
            /** 媒资类型 */
            mediaType: [
                {
                    label: "电视剧",
                    value: 1
                },
                {
                    label: "电影",
                    value: 2
                },
                {
                    label: "综艺",
                    value: 3
                },
                {
                    label: "少儿",
                    value: 4
                }
            ],
            /** 媒资状态 */
            status: [
                {
                    label: "上架",
                    value: 1
                },
                {
                    label: "下架",
                    value: 2
                }
            ],
            /** 初始化方式 */
            initialType: [
                {
                    label: "自动",
                    value: 1
                },
                {
                    label: "手动",
                    value: 2
                }
            ],
            /** 查看对话框 */
            viewDialog: false,
            viewForm: {
                drama: {
                    createTime: "",
                    episodes: 0,
                    id: 0,
                    isEnd: 0,
                    updateInstruction: "",
                    updateTime: "",
                    updatedEpisodes: 0
                },
                episodes: [
                    {
                        createTime: "",
                        duration: 0,
                        episodeName: "",
                        externalEpisodeMediaId: "",
                        id: 0,
                        mediaId: 0,
                        orderNum: 0,
                        updateTime: "",
                        url: "",
                        urlScheme: ""
                    }
                ],
                mediaAsset: {
                    aliasName: "",
                    coverImage: "",
                    createTime: "",
                    description: "",
                    duration: 0,
                    externalMediaId: "",
                    hasRelated: true,
                    hdImage: "",
                    id: 0,
                    isDeleted: 0,
                    language: "",
                    name: "",
                    primary: true,
                    productionCountry: "",
                    score: 0,
                    sourceType: 0,
                    status: 0,
                    tagName: "",
                    type: 0,
                    updateTime: "",
                    url: "",
                    urlScheme: "",
                    isShowIframe: false
                },
                staffMembers: [
                    {
                        createTime: "",
                        headImage: "",
                        id: 0,
                        isDeleted: 0,
                        mediaId: 0,
                        name: "",
                        orderNum: 0,
                        position: 0,
                        updateTime: ""
                    }
                ],
                /** 热度值 */
                hotval: null,
                /** 排序 */
                sortNo: null
            },
            /** 禁止编辑 */
            disabled: true,
            /** 是否来源于编辑 */
            isEdit: false,
            /** 编辑表单验证规则 */
            rules: {
                hotval: [
                    { required: true, message: "请输入热度值", trigger: "blur" },
                    {
                        type: "number",
                        message: "请输入正整数",
                        trigger: ["blur", "change"],
                        validator: (rule, value, callback) => {
                            if (/^[1-9]\d*$/.test(value)) {
                                callback();
                            } else {
                                callback(new Error());
                            }
                        }
                    }
                ],
                sortNo: [
                    { required: true, message: "请输入排序序号", trigger: "blur" },
                    {
                        type: "number",
                        message: "请输入正整数",
                        trigger: ["blur", "change"],
                        validator: (rule, value, callback) => {
                            if (/^[1-9]\d*$/.test(value)) {
                                callback();
                            } else {
                                callback(new Error());
                            }
                        }
                    }
                ]
            },
            /** 新增对话框表单数据 */
            addData: [],
            /** 新增对话框初始值 */
            addDialog: false,
            /** 新增对话框的搜索需要的数据*/
            addSearchForm: {
                name: null,
                type: null,
                sourceType: null,
                staffMemberName: null,
                current: 1,
                size: 10,
                total: 0
            },
            /** 保留新增选中态 */
            addSelectArr: [],
            /** 新增时媒资类型 */
            type: [
                {
                    label: "电视剧",
                    value: 1
                },
                {
                    label: "电影",
                    value: 2
                },
                {
                    label: "综艺",
                    value: 3
                },
                {
                    label: "少儿",
                    value: 4
                }
            ]
        };
    },
    created() {
        /** 渲染列表 */
        this.loadHotList();
    },
    methods: {
        //^ ^--------------load相关- -----------start^ ^
        /** 加载乐播榜数据 */
        async loadHotList() {
            this.isShowIframe = false;
            const { data } = await getHotList(this.searchForm);
            this.searchForm.total = data.data.total;
            /** 处理数据 */
            this.hotListData = data.data.records.map(item => {
                /** id */
                item.id = item.mediaAssetVO.id;
                /** 封面图 */
                item.coverImage = item.mediaAssetVO.coverImage
                    ? item.mediaAssetVO.coverImage
                    : "";
                /** 名称 */
                item.name = item.mediaAssetVO.name ? item.mediaAssetVO.name : "";
                /** 媒资类型 */
                item.type = item.mediaAssetVO.type;
                /** 热度值 */
                item.hotval = item.popularCastVO.hotval
                    ? item.popularCastVO.hotval
                    : "";
                /** 状态 */
                item.status = item.popularCastVO.status;
                /** 付费方式 */
                item.payType = formatPayType(item.platformPayTypeVOs);
                /** 方式 */
                item.initialType = item.popularCastVO.initialType;
                /** 播放源 */
                item.sourceType = item.mediaAssetVO.sourceType;
                /** 媒体标签 */
                item.tagName = item.mediaAssetVO.tagName
                    ? item.mediaAssetVO.tagName
                    : "";
                /** 媒体简介 */
                item.description = item.mediaAssetVO.description
                    ? item.mediaAssetVO.description
                    : "";
                /** 更新时间 */
                item.updateTime = item.popularCastVO.updateTime
                    ? item.popularCastVO.updateTime
                    : "";
                return item;
            });
            console.log("搜索的响应", this.hotListData);
            this.isShowIframe = true;
        },
        /** 切换标签页事件 */
        handleTabClick() {
            this.loadHotList();
        },
        /** 搜索事件 */
        handleSearch() {
            this.loadHotList();
            Message.success("检索成功");
        },
        /** 清空搜索事件 */
        handleClear() {
            this.searchForm.name = null;
            // this.searchForm.mediaType = null;
            this.searchForm.status = null;
            this.searchForm.sourceType = null;
            Message.success("清空成功");
        },
        /** 每页条数事件 */
        handleSizeChange(val) {
            this.searchForm.size = val;
            this.loadHotList();
            /** 提示用户 */
            Message.success(`每页 ${val} 条`);
        },
        /** 切换页码事件 */
        handleCurrentChange(val) {
            this.searchForm.current = val;
            this.loadHotList();
            /** 提示用户 */
            Message.success(`当前页: ${val}`);
        },
        //^ ^--------------load相关- -----------end^ ^

        //^ ^--------------表格查看/编辑相关- -----------end^ ^
        /** 取消人工干预事件 */
        async cancelIntervention(row) {
            console.log("取消人工干预获取id", row.id);
            const res = await updateHotListOrder({
                mediaId: row.id,
                sortNo: 0
            });
            console.log('取消人工干预的响应', res);
            /** 如果成功 */
            if (res.data.code === 200) {
                /** 提示用户 */
                Message.success("取消人工干预成功");
                /** 重新渲染列表 */
                this.loadHotList();
            }

        },
        async handleView(row, index) {
            this.viewDialog = true;
            // this.isShowIframe = false
            this.viewForm.mediaAsset.isShowHdImage = false;
            this.viewForm.mediaAsset.isShowCoverImage = false;
            this.viewForm.mediaAsset.isShowActorImage = false;
            console.log("查看详情获取id", row.id);
            const res = await getMediaDetail(row.id);
            /** 数据处理 */
            const list = res.data.data;
            /** 重新创建iframe */
            list.mediaAsset.isShowCoverImage = true;
            list.mediaAsset.isShowHdImage = true;
            list.mediaAsset.isShowActorImage = true;
            console.log("查看的响应", list);
            /** 处理封面图和高清横屏图 */
            console.log("封面图", list.mediaAsset.coverImage);
            console.log("高清横屏图", list.mediaAsset.hdImage);
            /** 处理单集时长1452s变为00:12:51这样的格式 */
            list.episodes.forEach(item => {
                const seconds = item.duration;
                const duration = moment.duration(seconds, "seconds");
                item.duration =
                    duration
                        .hours()
                        .toString()
                        .padStart(2, "0") +
                    ":" +
                    duration
                        .minutes()
                        .toString()
                        .padStart(2, "0") +
                    ":" +
                    duration
                        .seconds()
                        .toString()
                        .padStart(2, "0");
                /** 剧集类型 */
                // item.episodeType = item.episodeType === 1 ? '正片' : item.episodeType === 2 ? '预告片' : '其他'
            });
            /** 处理热度值 */
            list.hotval = Number(row.hotval);
            /** 处理排序 */
            list.sortNo = Number(index + 1);
            this.viewForm = list;
        },
        handleEdit(row, index) {
            console.log("编辑取到的数据", row, index);
            this.isEdit = true;
            /** 回填热度值 */
            this.viewForm.hotval = Number(row.hotval);
            /** 回填排序 */
            this.viewForm.sortNo = Number(index);
            console.log("回填热度值", this.viewForm.hotval);
            console.log("回填排序", this.viewForm.sortNo);
            this.handleView(row, index);
        },
        /** 上架热门投屏影片 */
        async handlePuton(row) {
            console.log("取到的数据", row);
            /** 询问是否确定上架 */
            this.$confirm("是否确定上架该热门投屏影片?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    const res = await takeOnHotList(row.id);
                    console.log("上架热门投屏影片的响应", res);
                    /** 如果上架成功 */
                    if (res.data.code === 200) {
                        Message.success("上架成功");
                    }
                    /** 重新加载数据 */
                    this.loadHotList();
                })
                .catch(() => {
                    Message.info("已取消上架");
                });
        },
        /** 下架热门投屏影片 */
        async handleTokeOff(row) {
            /** 询问是否确定下架 */
            this.$confirm("是否确定下架该热门投屏影片?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    const res = await takeOffHotList(row.id);
                    console.log("下架热门投屏影片的响应", res);
                    /** 如果下架成功 */
                    if (res.data.code === 200) {
                        Message.success("下架成功");
                    }
                    /** 重新加载数据 */
                    this.loadHotList();
                })
                .catch(() => {
                    Message.info("已取消下架");
                });
            console.log("下架取到的数据", row);
        },
        /** 取消编辑 */
        editDialogCancel() {
            this.viewDialog = false;
            /** 清除表单验证规则 */
            this.$refs["viewForm"].resetFields();
        },
        /** 确认编辑 */
        async editDialogConfirm() {
            /** 如果表单验证通过才往下走 */
            this.$refs["viewForm"]
                .validate()
                .then(async () => {
                    /** 再修改排序 */
                    const res2 = await updateHotListOrder({
                        mediaId: this.viewForm.mediaAsset.id,
                        sortNo: this.viewForm.sortNo
                    });
                    /** 如果成功 */
                    if (res2.data.code === 200) {
                        Message.success("修改成功");
                    }
                    /** 重新加载数据 */
                    this.loadHotList();
                    /** 关闭弹出框 */
                    this.viewDialog = false;
                })
                .catch(() => {
                    return Message.error("表单验证不通过");
                });
        },
        //^ ^--------------新增媒资对话框内相关-------------start^ ^
        //加载新增弹出框内数据
        async loadAddList() {
            console.log("多选状态数组", this.addSelectArr);

            /** 加载媒资数据 */
            const { data } = await getPrimaryMedia(this.addSearchForm);
            console.log("load媒资库数据的响应", data);
            /** 对数据进行处理 */
            const list = data.data.records;
            this.addSearchForm.total = data.data.total;
            /** 每一项数据加一个select */
            list.forEach(item => {
                item.isChecked = false;
                item.sortNo = "";
                item.indexRules = [];
                /** 付费方式 */
                item.payType = formatPayType(item.platformPayTypes);
            });
            /** 数据赋值 */
            this.addData = list;
        },
        //处理新增弹出的事件
        handleAdd() {
            console.log("新增的事件触发");
            this.addSearchForm.type = this.searchForm.mediaType;
            /** 调用加载add数据的方法 */
            this.loadAddList();
            /** 新增对话框 */
            this.addDialog = true;
        },
        //新增对话框的搜索事件
        handleAddSearch() {
            /** 调用加载add数据方法 */
            this.loadAddList();
            /** 提示用户 */
            Message.success("搜索成功！");
        },
        /** 清空搜索框事件 */
        handleAddClear() {
            console.log("清空事件触发");
            /** 清空搜索栏数据 */
            this.addSearchForm.name = null;
            this.addSearchForm.type = null;
            this.addSearchForm.sourceType = null;
            this.addSearchForm.staffMemberName = null;
            Message.success("清空成功！");
        },
        /** 新增当前页切换事件 */
        handleAddCurrentChange(val) {
            console.log("当前页切换事件", val);
            /** 赋值 */
            this.addSearchForm.current = val;
            /** 调用加载add数据方法 */
            this.loadAddList();
            /** 提示用户 */
            Message.success(`当前页: ${val}`);
        },
        /** 新增每页条数更改事件 */
        handleAddSizeChange(val) {
            console.log("每页条数更改事件", val);
            /** 赋值 */
            this.addSearchForm.size = val;
            /** 调用加载add数据方法 */
            this.loadAddList();
            /** 提示用户 */
            Message.success(`每页 ${val} 条`);
        },
        /** 新增多选媒资事件触发 */
        selectMedia(selection) {
            console.log("新增选择媒资事件触发", selection);
            this.addSelectArr = selection;
            this.addData.forEach(item => {
                if (selection.id === item.id) {
                    item.isChecked = true;
                    item.sortNo = selection.sortNo;
                } else {
                    item.isChecked = false;
                    item.sortNo = "";
                }
            });
        },
        /** 查看乐播榜详情 */
        async handleGetDetail(id) {
            this.handleView(id);
        },
        /** 新增取消事件 */
        handleAddCancel() {
            console.log("新增取消事件触发");
            /** 清空搜索栏数据 */
            this.addSearchForm = {
                name: null,
                type: null,
                sourceType: null,
                staffMemberName: null,
                current: 1,
                size: 10,
                total: 0
            };
            /** 清空新增对话框数据 */
            this.addData = [];
            /** 清空多选状态 */
            this.addSelectArr = [];
            /** 新增对话框 */
            this.addDialog = false;
        },
        /** 确认新增事件 */
        async handleAddConfirm() {
            console.log("确认新增事件触发");
            console.log("新增多选数组", this.addSelectArr);
            /** 验证表单 */
            if (!this.addSelectArr.id) {
                return Message.error("请选择媒资");
            } else {
                /** 验证表单规则 */
                this.$refs["addDataForm"].validate(async valid => {
                    if (!valid) {
                        return Message.error("请输入排序序号");
                    }
                    /** 验证通过 */
                    /** 调用新增的接口 */
                    const res = await addHotList({
                        mediaId: this.addSelectArr.id,
                        sortNo: this.addSelectArr.sortNo
                    });
                    console.log("新增的响应", res);
                    /** 如果新增成功 */
                    if (res.data.code === 200) {
                        Message.success("新增成功");
                        /** 重新加载数据 */
                        this.loadHotList();
                        /** 新增对话框 */
                        this.addDialog = false;
                        /** 清除新增媒资id */
                        this.addSelectArr = null;
                        /** 清空搜索栏数据 */
                        this.addSearchForm = {
                            name: null,
                            type: null,
                            sourceType: null,
                            staffMemberName: null,
                            current: 1,
                            size: 10,
                            total: 0
                        };
                        /** 清空新增对话框数据 */
                        this.addData = [];
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.red {
    color: red;
}

.gary {
    color: #999;
}

.showMediaImg {
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.showMediaImg-left {
    width: 40%;
    height: 50%;
    margin-right: 1.25rem;
}

.showMediaImg-right {
    margin-right: 75px;
    width: 40%;
    height: 50%;
}

.mediaImg {
    width: 100%;
    height: 100%;
}

.correlate-description {
    width: 32.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
</style>
